import React, { useState } from 'react';
import { Icon, Menu, Dropdown, Modal, Input } from 'antd';
import { updateMessageChannel } from '../api';
import { useGlobalState } from '../state';

const NEW_BRANCH = "New";

function BranchMessageAction({ message }) {
  const [messagesByChannel,] = useGlobalState('messagesByChannel');
  const channels = Object.keys(messagesByChannel)
    .filter(channel => channel !== message.branch);
  const [, setCurrentChannel] = useGlobalState('currentChannel');

  const [isNewChannelModalVisible, setNewChannelModalVisible] = useState(false);
  const [newChannelName, setNewChannelName] = useState('');

  const channelsMenu = (
    <Menu
      onClick={async ({ key }) => {
        if (key === NEW_BRANCH) {
          setNewChannelModalVisible(true);
        } else {
          await updateMessageChannel(message.id, key);
          setCurrentChannel(key);
        }
      }}
    >
      <Menu.Item key={NEW_BRANCH}>
        <Icon type="plus-circle" />
        {NEW_BRANCH}
      </Menu.Item>
      {channels.map(channel => (
        <Menu.Item key={channel}>
          {channel}
        </Menu.Item>
      ))}
    </Menu>
  );

  const onNewChannelSubmit = async () => {
    setNewChannelModalVisible(false);
    await updateMessageChannel(message.id, newChannelName);
    setCurrentChannel(newChannelName);
  };

  return (
    <span>
      <Dropdown overlay={channelsMenu}>
        <span>
          <Icon
            type="branches"
          />
        </span>
      </Dropdown>
      <Modal
        title="New Channel"
        visible={isNewChannelModalVisible}
        onOk={onNewChannelSubmit}
        onCancel={() => { setNewChannelModalVisible(false); }}
      >
        <Input
          placeholder="Channel name"
          onChange={event => { setNewChannelName(event.target.value) }}
          onPressEnter={onNewChannelSubmit}/>
      </Modal>
    </span>
  );
}

export default BranchMessageAction;
